/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React, { useRef } from "react";
import {
  Button,
  ContextualMenu,
  ContextualMenuContent,
  ContextualMenuItem,
  MoreHorizontalIcon,
  Tooltip
} from "@forge/common";

interface MenuItem {
  id: string;
  label: string;
  onClick: () => void;
}

export const ContextualMenuComponent = ({
  menuItems,
  disabled,
  provider
}: {
  menuItems: MenuItem[];
  provider?: string;
  disabled?: boolean;
}) => {
  const anchorRef = useRef(null);

  return (
    <>
        <Button
          ref={anchorRef}
          data-testid="contextual-menu-button"
          variant="quiet-primary"
          icon={<MoreHorizontalIcon strokeWidth={2.5} />}
          aria-label="More"
          disabled={disabled || false}
        />
      <ContextualMenu anchor={anchorRef}>
        <ContextualMenuContent>
          {menuItems.map((item) => (
            <ContextualMenuItem
              key={item.id}
              as="button"
              id={item.id}
              onClick={item.onClick}
              label={item.label}
            />
          ))}
        </ContextualMenuContent>
      </ContextualMenu>
    </>
  );
};
